import { defineStore } from 'pinia'
import { ref } from 'vue'
import socket from '@/common/socket'

const initState = {
  token: '',
  userid: '',
  username: '',
  realname: '',
  welcome: '',
  avatar: '',
  tenantId: 0,
  phone: '',
  email: '',
  sex: 1,
  birthday: '',
  loginTenantId: 0,
  // 本地存储时间
  localStorageTime: 0,
  // 组织编码名称
  orgCodeTxt: '',
}

export const useUserStore = defineStore(
  'user',
  () => {
    const userInfo = ref<IUserInfo>({ ...initState })
    const setUserInfo = (val: IUserInfo) => {
      if (val?.loginTenantId) {
        val.tenantId = val.loginTenantId
      }
      userInfo.value = val
      socket?.init('websocket')
    }
    const clearUserInfo = () => {
      userInfo.value = { ...initState }
      socket?.closeSocket()
    }
    const getUserInfo = () => {
      return userInfo.value
    }
    const editUserInfo = (options) => {
      userInfo.value = { ...userInfo.value, ...options }
    }
    const setTenant = (tenantId) => {
      userInfo.value.tenantId = tenantId
    }
    const getTenant = () => {
      return userInfo.value.tenantId
    }
    // 一般没有reset需求，不需要的可以删除
    const reset = () => {
      userInfo.value = { ...initState }
    }
    /**
     * 获取用户ID
     * @returns {string} 用户唯一标识
     */
    const getUserId = () => {
      return userInfo.value?.id || ''
    }
    /**
     * 获取用户姓名
     * 优先返回真实姓名，如果没有则返回用户名
     * @returns {string} 用户姓名
     */
    const getUserName = () => {
      return userInfo.value?.realname || userInfo.value?.username || ''
    }
    /**
     * 获取用户头像URL
     * @returns {string} 头像URL地址
     */
    const getUserAvatar = () => {
      return userInfo.value?.avatar || ''
    }

    /**
     * 清除用户会话信息
     * 包括令牌和用户信息，用于退出登录
     */
    const clearSession = () => {
      clearUserInfo()
      uni.removeStorageSync('token')
      uni.removeStorageSync('userInfo')
    }

    /**
     * 用户退出登录
     * 清除所有用户数据并跳转到登录页
     */
    const logout = () => {
      clearSession()
      // 跳转到登录页
      uni.reLaunch({
        url: '/pages/login/login',
      })
    }
    const isLogined = computed(() => !!userInfo.value.token)
    return {
      userInfo,
      setUserInfo,
      getUserInfo,
      clearUserInfo,
      setTenant,
      getTenant,
      isLogined,
      editUserInfo,
      reset,
      getUserId,
      getUserName,
      getUserAvatar,
      logout,
    }
  },
  {
    // 如果需要持久化就写 true, 不需要持久化就写 false（或者去掉这个配置项）
    persist: true,
  },
)
